import React, { useState, useEffect } from 'react'
import { useParams, Link } from 'react-router-dom'
import { Form, Button, Modal, Image, Row, Col, Nav, Tab } from "react-bootstrap";
import { toast } from 'react-toastify';

import jwt_decode from "jwt-decode";
import { serverUrl } from "../../serverUrl";
import { useNavigate } from 'react-router'
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

function SelectedHouseImage() {
    const { id } = useParams();
    const navigate = useNavigate()

    // image
    const [images, setImages] = useState([]);
    const [formData, setFormData] = useState({
        Houseimg: [],
    });
    // button that does the uploading to while the input is hidden
    const handleButtonClick = () => {
        document.getElementById('imageUpload').click();
    };
    const handleChange = (event) => {
        const selectedImages = Array.from(event.target.files);

        if (selectedImages.length > 0) {
            setImages(selectedImages);
            setFormData((prevFormData) => ({
                ...prevFormData,
                Houseimg: selectedImages,
            }));
        } else {
            setImages([]);
            setFormData((prevFormData) => ({
                ...prevFormData,
                Houseimg: [],
            }));
            toast.error('Kindly select image(s)!');
        }
    };

    // get user details so that you can link with the Apartment from the access tokens
    const accessToken = localStorage.getItem("authTokens");
    const decodedToken = jwt_decode(accessToken);
    const userId = decodedToken.user_id;
    const parsedTokens = JSON.parse(accessToken);
    const access = parsedTokens.access;
    const config = {
        headers: { Authorization: `Bearer ${access}` }
    }
    const [apartmentImages, setApartmentImages] = useState([])

    // handling the form and how the data will be sent to the backend
    function handleSubmit(e) {
        e.preventDefault();
        const accessToken = localStorage.getItem("authTokens");
        const decodedToken = jwt_decode(accessToken);
        const userId = decodedToken.user_id;
        const data = new FormData();
        data.append('house', id);
        data.append('image', formData.Houseimg);
        const parsedTokens = JSON.parse(accessToken);
        const access = parsedTokens.access;
        const config = {
            headers: { Authorization: `Bearer ${access}` }
        }
        const uploadPromises = formData.Houseimg.map((image, index) => {
            const data = new FormData();
            data.append('house', id);
            data.append(`image`, image);

            const parsedTokens = JSON.parse(accessToken);
            const access = parsedTokens.access;

            const config = {
                headers: { Authorization: `Bearer ${access}` },
            };

            return serverUrl.post('/landlord/house-images/', data, config);
        });

        Promise.all(uploadPromises)
            .then((results) => {
                console.log(results);
                toast.success('Successfully Added Unit Images!');
                setImages([]);
                serverUrl.get(`/landlord/house-images/?house_id=${id}`, config)
                    .then((res) => {
                        setApartmentImages(res.data.results);
                    })
                    .catch((error) => {
                        console.log(error);
                    });

            })
            .catch((error) => {
                toast.error(error.message || 'Error adding unit images');
            });

    }

    // images modal
    const [showModalHouse, setShowModalHouse] = useState(false)
    const handleOpenModalHouse = () => {
        setShowModalHouse(true);
    };
    const handleCloseModalHouse = () => {
        setShowModalHouse(false);
    };

    useEffect(() => {
        serverUrl.get(`/landlord/house-images/?house_id=${id}`, config)
            .then((res) => {
                setApartmentImages(res.data.results)
            })
            .catch((error) => {
                console.log(error)
            })
    }, [id])

    // delete the image
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedApartmentId, setSelectedApartmentId] = useState(null);
    const openModal = (apartmentId) => {
        setSelectedApartmentId(apartmentId);
        setIsModalOpen(true);
    };
    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedApartmentId(null);
    };
    const handleDeleteApartment = () => {
        if (selectedApartmentId) {
            serverUrl.delete(`/landlord/house-image/${selectedApartmentId}`, config)
                .then((res) => {
                    serverUrl.get(`/landlord/house-images/?house_id=${id}`, config)
                        .then((res) => {
                            setApartmentImages(res.data.results)
                            closeModal();

                        })
                        .catch((error) => {
                            console.log(error)
                        })
                    toast.success('Succesfully deleted the image')
                })
                .catch((error) => {
                    console.log(error)
                })
        }
    }
    const slickSettings = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: Math.max(1, Math.min(3, apartmentImages.length)),
        slidesToScroll: 1,
    }
    const slickSettingsUploaded = {
        dots: true,
        infinite: true,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
    };
    const [activeTab, setActiveTab] = useState('viewImages');
    const handleTabChange = (tab) => {
        setActiveTab(tab);
    };


    return (

        <>
            <div className="bg-white p-4 rounded shadow-md mt-4">
                <h2 className='mb-3'>Add Unit Image(s)</h2>

                <div className=' w-100'>
                    <Tab.Container activeKey={activeTab} onSelect={handleTabChange}>
                        <Nav variant='tabs' className='flex mb-2 border-b border-gray-200'>
                            <Nav.Item className="mr-2">
                                <Nav.Link
                                    eventKey='viewImages'
                                    className={`
                                         px-4 py-2 rounded-t
                                         ${activeTab === 'viewImages'
                                            ? 'bg-primary text-white font-semibold'
                                            : 'bg-blue-50 text-dark hover:bg-blue-100'
                                        }
                                         transition-colors duration-200
                                         border border-b-0 border-gray-200
                                         focus:outline-none
                                       `}
                                    style={{ minWidth: 'fit-content' }}
                                >
                                    View Property's Images
                                </Nav.Link>
                            </Nav.Item>
                            <Nav.Item>
                                <Nav.Link
                                    eventKey='selectImages'
                                    className={`
                                         px-4 py-2 rounded-t
                                         ${activeTab === 'selectImages'
                                            ? 'bg-primary text-white font-semibold'
                                            : 'bg-blue-50 text-dark hover:bg-blue-100'
                                        }
                                         transition-colors duration-200
                                         border border-b-0 border-gray-200
                                         focus:outline-none
                                       `}
                                    style={{ minWidth: 'fit-content' }}
                                >
                                    Select Image For Property
                                </Nav.Link>
                            </Nav.Item>
                        </Nav>

                        <Tab.Content>
                            <Tab.Pane eventKey='viewImages'>
                                {apartmentImages && apartmentImages.length > 0 ? (
                                    <div>

                                        <Slider {...slickSettings} style={{ marginLeft: '0rem' }}>
                                            {apartmentImages.map((apartment) => (
                                                <div key={apartment.id}>
                                                    <Col md={6} sm={6} style={{ marginTop: '1rem' }}>
                                                        <span
                                                            className='mt-4'
                                                            onClick={() => openModal(apartment.id)}
                                                            style={{
                                                                position: 'relative',
                                                                padding: '0.8rem',
                                                                backgroundColor: 'red',
                                                                borderRadius: '50%',
                                                                marginLeft: '-10rem',
                                                            }}
                                                        >
                                                            <i className='bi bi-trash-fill text-white' style={{ position: 'relative' }}></i>
                                                        </span>
                                                        <Image className='propertiesViewImage' src={apartment.image} />
                                                    </Col>
                                                </div>
                                            ))}
                                        </Slider>

                                        <Modal show={isModalOpen} onHide={closeModal}>
                                            <Modal.Header closeButton>
                                                <Modal.Title>Delete Image</Modal.Title>
                                            </Modal.Header>
                                            <Modal.Body>
                                                <p>Do you want to delete this image?</p>
                                            </Modal.Body>
                                            <Modal.Footer>
                                                <button className='btn btn-danger' onClick={handleDeleteApartment}>
                                                    Delete
                                                </button>
                                                <button className='btn btn-secondary' onClick={closeModal}>
                                                    Close
                                                </button>
                                            </Modal.Footer>
                                        </Modal>
                                    </div>
                                ) : (
                                    <p style={{ fontSize: "2rem" }}>No Images found kindly add one </p>
                                )}

                            </Tab.Pane>

                            <Tab.Pane eventKey='selectImages'>
                                <Form onSubmit={handleSubmit} encType='multipart/form-data'>
                                    <div className='input-icons'>
                                        <Button className='imageButton btn btn-sm mt-3' onClick={handleButtonClick}>
                                            Choose image(s) to upload
                                        </Button>
                                        <input type='file' id='imageUpload' accept='image/*' multiple style={{ display: 'none' }} onChange={handleChange} />

                                        {images.length > 0 && (
                                            <>
                                                <div className='d-flex' style={{ width: "100%", overflowX: "scroll" }}>
                                                    {images.map((image, index) => (
                                                        <>
                                                            {/* <p className="imageSize">{(image.size / 1024).toFixed(2)} KB</p> */}
                                                            <br></br>

                                                            <div key={index} className="imageContainer d-flex">
                                                                <span
                                                                    className='mt-1'
                                                                    onClick={() => setImages(images.filter((_, i) => i !== index))}

                                                                    style={{
                                                                        position: 'relative',
                                                                        padding: '0.8rem',
                                                                        backgroundColor: 'red',
                                                                        borderRadius: '50%',
                                                                        marginRight: '-4rem',
                                                                        height: "fit-content",
                                                                    }}
                                                                >
                                                                    <i className='bi bi-trash-fill text-white' style={{ position: 'relative' }}></i>
                                                                </span>

                                                                <img
                                                                    src={URL.createObjectURL(image)}
                                                                    alt={`preview_${index}`}
                                                                    className='imageUploaded'
                                                                    style={{ marginInline: "1.2rem", width: "20vw", objectFit: "cover" }}
                                                                />
                                                                <br></br>
                                                            </div>

                                                            <br></br>

                                                        </>

                                                    ))}

                                                </div>
                                                <div className='bottomButtons w-100 mt-4'>
                                                    <Button type='submit' className='nextButton  btn btn-sm'>
                                                        Save Images
                                                    </Button>
                                                </div>
                                            </>

                                        )}

                                    </div>
                                </Form>
                            </Tab.Pane>
                        </Tab.Content>
                    </Tab.Container>
                </div>


            </div>
        </>
    )
}

export default SelectedHouseImage